import {
  Component,
  Event,
  EventEmitter,
  Fragment,
  h,
  JSX,
  Prop,
} from "@stencil/core";
import { Account, TLink } from "@phn/entities/content";
import { GlobalDataLayerService } from "@phn/services/analytics/global-data-layer-service";
import {
  ClickElementTypes,
  ElementTypes,
  EventActions,
} from "@phn/utility/constants";
import { getConfig } from "@phn/utility/helper";
import { RoutingKeys } from "@phn/entities/routing-key";
import { Timeout } from "@phn/utility/timeout";
import { loginWithRedirect } from "@phn/services/user-service";
import { navStateStore } from "@phn/state/nav-state-store";
import {
  dispatchAuthEvent,
  PHN_AUTH_EVENT,
} from "@phn/services/auth-event.service";
import { NavigationPageAction } from "@phn/services/micro-agent-wrapper";
import { enqueueEvent } from "@phn/services/event-queue.service";
import analyticsManager from "../../services/analytics/analytics-manager";

@Component({
  tag: "phn-nd-pcom-login",
  styleUrl: "pcom-login.scss",
  scoped: true,
})
export class PcomLogin {
  @Prop() content: Account;

  @Event({ composed: true, bubbles: true, cancelable: true })
  phnLogin!: EventEmitter<void>;

  private eventPreventedTimeout = new Timeout(0);

  private sendDataLayerEvent(link: TLink | null): void {
    GlobalDataLayerService.getInstance().pushDataLayerEvent(
      EventActions.NAVIGATION_LINK_CLICK,
      {
        componentClick: {
          clickElementId: link.id,
          clickElementName: link.text,
          clickElementType: ClickElementTypes.Link,
        },
        componentDisplay: {
          displayElementId: analyticsManager.calculateDisplayElementId(),
          displayElementType: analyticsManager.calculateDisplayElementType(
            RoutingKeys.ACCOUNT,
            ElementTypes.accountDrawer,
          ),
          displayElementName: link.text,
        },
      },
    );
  }

  handleLogin() {
    const phnLogin = this.phnLogin.emit();

    this.eventPreventedTimeout.set(() => {
      if (phnLogin.defaultPrevented) {
        enqueueEvent({ type: NavigationPageAction.THIRD_PARTY_LOGIN });
        dispatchAuthEvent({
          eventType: PHN_AUTH_EVENT.LOGIN_DEFAULT_PREVENTED,
        });
        return;
      }
      const config = getConfig(navStateStore.state.env);

      loginWithRedirect(config);
    });
  }

  render(): JSX.Element {
    const { login, welcome, signIn } = this.content;
    return (
      <Fragment>
        <div class="button-container">
          <phn-p-text size="inherit" class="headline">
            {welcome}
          </phn-p-text>
          <phn-p-text size="small" color="contrast-medium" class="subline">
            {signIn}
          </phn-p-text>
          <phn-p-button
            variant="primary"
            class="login"
            onClick={() => {
              this.handleLogin();
              this.sendDataLayerEvent(login);
            }}
          >
            {login.text}
          </phn-p-button>
        </div>
      </Fragment>
    );
  }
}
